<template>
    <b-modal :no-close-on-backdrop="true"
        size="lg"
        id="modal-Create"
        :title="title"
        hide-footer 
        :centered="true"
        v-model="open">
        <b-form class="pb-20">
            <gofix-table :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                ref="gofixTable">
                <template slot="gofix_table:adjust" slot-scope="row">
                    <gofix-form-input-number 
                        allowNegative 
                        :integer-limit="3" 
                        suffix="%"
                        :include-thousands-separator="false"
                        label=""
                        v-model="row.item.adjust"></gofix-form-input-number>
                </template>
            </gofix-table>
        </b-form>
        <b-button-group class="d-block text-right">
            <gofix-button label="EXPORT" @click="saveData" :loading="loading" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>

<script>
    export default {
        name: 'modal-final-report',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: 'Final Report'
            },
            dataTable: {
                type: Array,
                default: []
            },
            dataParam: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                open: false,
                loading: false,
                timer: {
                    
                },
                tableConfig:{
                    name: 'table-final-report',
                    controls:{
                        create: false,
                        update: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        reload: false,
                        tablePagination: false,
                        tableFilter: false
                    },
                    filter: {
                        contract_id: {type: "number", value: null, function:"=", with: []},
                        property_type: {type: "text", value: "", function:"ilike", with: []},
                    },
                    page: 1,
                    limit: 100,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'location_name',
                            label: 'Location',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'adjust',
                            label: 'Adjust',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-right',
                            tdClass: 'text-right'
                        },
                    ]
                },
                tableItems: []
            }
        },
        watch: {
            value: function(val) {
                this.open = val;
            },
            open: function(val) {
                this.$emit('input', val);
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                const response = {
                    items: JSON.parse(JSON.stringify(this.dataTable)),
                    total: this.dataTable.length
                }
                this.tableItems = response.items
                this.tableConfig.total = response.total
                resolve(response);
            },
            async saveData() {
                let newData = this.tableItems.map(function(item) {
                    return {
                        location_id: item.location_id,
                        adjust: item.adjust
                    }
                });

                let totalPercent = 0

                newData.map(item => {
                    item.adjust = this.$accounting.unformat(item.adjust)
                    totalPercent = totalPercent + item.adjust
                })

                if ( totalPercent > 100 ) {
                    return this.$alertNotification("Total Adjust must be less than or equal to 100%", "danger")
                }
                
                this.dataParam['location_adjusts'] = newData
                
                await this.$store.dispatch("PAConservancyController/exportInterimReportReport", this.dataParam)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'final-report-' + this.dataParam.month + '-' + this.dataParam.year + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(err => { })
            }
        }
    }
</script>